import { useVariant } from "../../context/VariantContext";
import { PILLARS, IMAGES } from "../../data/content";
import { Reveal } from "./Reveal";
import { SectionEyebrow } from "./About";

export const Method = () => {
  const { variant } = useVariant();
  const isVault = variant === "vault";

  return (
    <section
      id="method"
      data-testid="method"
      className={`relative overflow-hidden border-t px-6 py-28 lg:px-10 lg:py-36 ${
        isVault ? "grain" : ""
      }`}
      style={{ borderColor: "var(--border)" }}
    >
      <div className="mx-auto max-w-7xl">
        <div className="grid grid-cols-1 items-end gap-8 lg:grid-cols-12">
          <div className="lg:col-span-7">
            <Reveal>
              <SectionEyebrow index="04">The Method</SectionEyebrow>
              <h2 className="font-head mt-6 max-w-2xl text-4xl leading-tight text-[color:var(--text)] sm:text-5xl">
                A universal four-pillar approach to authenticity.
              </h2>
            </Reveal>
          </div>
          <div className="lg:col-span-4 lg:col-start-9">
            <Reveal delay={0.1}>
              <p className="text-[15px] leading-relaxed text-[color:var(--text-2)]">
                Genuine expertise takes years to build. Every verdict is grounded in
                a repeatable framework — verified with all the senses, cross-referenced
                against decades of maison-specific reference.
              </p>
            </Reveal>
          </div>
        </div>

        <div className="mt-16 grid grid-cols-1 gap-px border sm:grid-cols-2 lg:grid-cols-4"
          style={{ borderColor: "var(--border)", background: "var(--border)" }}>
          {PILLARS.map((p, i) => (
            <Reveal key={p.n} delay={i * 0.08}>
              <div
                className="group h-full px-7 py-10 transition-colors"
                style={{ background: "var(--surface)" }}
              >
                <span
                  className="font-accent text-xs tracking-[0.2em]"
                  style={{ color: "var(--accent)" }}
                >
                  {p.n}
                </span>
                <h3
                  className={`font-head mt-5 text-2xl text-[color:var(--text)] ${
                    variant === "swiss" ? "font-bold tracking-tight" : ""
                  }`}
                >
                  {p.title}
                </h3>
                <p className="mt-4 text-sm leading-relaxed text-[color:var(--text-2)]">
                  {p.desc}
                </p>
              </div>
            </Reveal>
          ))}
        </div>

        <Reveal delay={0.15}>
          <div className="mt-16 grid grid-cols-2 gap-4 sm:grid-cols-3">
            {[IMAGES.handbag, IMAGES.watch, IMAGES.handbag2].map((src, i) => (
              <div
                key={i}
                className={`overflow-hidden border ${i === 2 ? "hidden sm:block" : ""}`}
                style={{ borderColor: "var(--border)", borderRadius: "var(--radius-tok)" }}
              >
                <img
                  src={src}
                  alt="Luxury goods detail"
                  className="aspect-square w-full object-cover transition-transform duration-700 hover:scale-105"
                />
              </div>
            ))}
          </div>
        </Reveal>
      </div>
    </section>
  );
};
